export default "__VITE_ASSET__CfhTOOZI__"